__turbopack_context__.v({
  "input": "switch-module-scss-module__xddZ1q__input",
  "slider": "switch-module-scss-module__xddZ1q__slider",
  "toggle": "switch-module-scss-module__xddZ1q__toggle",
});
